import { MobileBasket } from './mobileBasket';
import { isDesktopLayout } from 'components/Shared/responsive';
import { DesktopBasket } from './desktopBasket';
import connect from 'components/Shared/connect';

interface OwnProps {
  className?: string;
}
interface MergedProps extends OwnProps {
  isDesktop: boolean;
}

export const Basket = connect<MergedProps, OwnProps>(state => ({
  isDesktop: isDesktopLayout(state)
}))(({ isDesktop, className }: MergedProps) =>
  isDesktop ? <DesktopBasket className={className} /> : <MobileBasket className={className} />
);
